var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3c-4.972 0-9 4.028-9 9s4.028 9 9 9 9-4.028 9-9-4.028-9-9-9Zm0 16.839c-4.322 0-7.839-3.517-7.839-7.839 0-4.322 3.517-7.839 7.839-7.839 4.322 0 7.839 3.517 7.839 7.839 0 4.322-3.517 7.839-7.839 7.839Zm-1.15-8.764 2.613.733a2.188 2.188 0 0 1 1.596 2.086c0 1.198-.987 2.17-2.195 2.17h-.283v1.452c0 .16-.131.29-.29.29h-.581c-.16 0-.29-.13-.29-.29v-1.451h-.19c-.689 0-1.342-.23-1.872-.65a.292.292 0 0 1-.029-.436l.41-.417a.288.288 0 0 1 .377-.029c.316.236.705.367 1.111.367h1.633c.57 0 1.034-.454 1.034-1.01 0-.446-.308-.845-.747-.968l-2.613-.733a2.184 2.184 0 0 1-1.593-2.087c0-1.198.987-2.17 2.195-2.17h.283V6.48c0-.16.131-.29.29-.29h.581c.16 0 .29.13.29.29v1.452h.186c.69 0 1.342.228 1.872.65a.292.292 0 0 1 .03.435l-.41.417a.288.288 0 0 1-.378.03 1.853 1.853 0 0 0-1.11-.367h-1.634c-.57 0-1.034.453-1.034 1.009 0 .446.309.845.748.969Z"
  })));
};

export default SvgDollarCircle;